import Announcement from './announcement'
import Auth from './auth'
import City from './city'
import Industry from './industry'
import Company from './company'
import CompanyCreditRecord from './companyCreditRecord'
import Expert from './expert'
import Project from './project'
import Guarantor from './guarantor'
import Guarantee from './guarantee'
import Receipt from './receipt'
import ProjectRegister from './projectRegister'
import GuaranteeTemplate from './guaranteeTemplate'
import Supervisor from './supervisor'
import BasicPermission from './basicPermission'
import Role from './role'
import KVS from './kvs'
import Statistics from './statistics'
import Appraisal from './appraisal'
import Crawler from './crawler'

const Api = {
  Announcement,
  Auth (inst) {
    return new Auth(inst)
  },
  BasicPermission,
  Role,
  City,
  Industry,
  Company,
  CompanyCreditRecord,
  Expert,
  Project,
  Guarantor,
  GuaranteeTemplate,
  Guarantee,
  Receipt,
  ProjectRegister,
  Supervisor,
  Statistics,
  Appraisal,
  KVS,
  Crawler
}

export default Api